













































































import Component, { mixins } from 'vue-class-component';
import { required } from 'vuelidate/lib/validators';
import { mapState, mapActions } from 'vuex';
import { GPageBase } from '@/mixins';
import { StringUtils } from '@/utils/string.utils';
import { GEnum } from '@/constants/enum.defination';
import { MesssgeModal } from '@/models/message-modal';
import { resetPasswordModule } from '@/store/modules/entities/reset-password.module';
import GVTag from '@/components/GVTag.vue';
import { TeacherPasswordReset } from '@/models/teacher/teacher-password-request';
import { Constants } from '@/constants/constants';

@Component({
  name: 'GResetPasswordStep2',
  components: { GVTag },
  computed: {
    ...mapState('resetPassword', ['email']),
  },
  methods: {
    ...mapActions(['handleBackToHome']),
  },
  validations: {
    password: { required },
    passwordConfirm: { required },
    form: ['password', 'passwordConfirm'],
  },
})
export default class GResetPasswordStep2 extends mixins(GPageBase) {
  messageModal: MesssgeModal = { type: GEnum.MessageType.Success, isShow: false, isContinue: false };
  messageType = GEnum.MessageType;
  isPasswordReset: boolean = false;
  isTeacherValid: boolean = false;
  isResetRequestValid: boolean = false;
  errSamePassword: boolean = false;

  mounted() {
    this.validateToken();
  }
  handleResetPassword() {
    this.messageModal.isShow = false;
    this.messageModal.isContinue = false;
    this.touchPage();
    if (this.isPageInvalid) {
      return;
    }
    resetPasswordModule
      .resetPassword()
      .then(_ => {
        this.messageModal.type = GEnum.MessageType.Success;
        this.messageModal.title = this.INFO_TITLE;
        this.messageModal.content = this.UPDATE_SUCCESSED_MESSAGE;
      })
      .catch((err: any) => {
        this.messageModal.type = GEnum.MessageType.Error;
        this.messageModal.title = this.INFO_TITLE;
        if (err.data.category === GEnum.ErrorCategory.GrowApi) {
          this.messageModal.content = this.$t(`GROW_API_ERROR_MESSAGE_CODE.${err.data.code}`).toString();
        } else if (err.data.category === GEnum.ErrorCategory.AuthApi) {
          // 同じパスワードを設定しているエラーに対してだけは今の画面のまま操作する
          if (err.data.code == 15) {
            this.messageModal.isContinue = true;
          }
          this.messageModal.content = this.$t(`AUTH_ERROR_MESSAGE_CODE.${err.data.code}`).toString();
        } else {
          this.messageModal.content = this.UPDATE_FAILED_MESSAGE;
        }
      })
      .finally(() => {
        this.messageModal.isShow = true;
      });
  }

  touchPage() {
    this.$v.password.$touch();
    this.$v.passwordConfirm.$touch();
  }

  validateToken() {
    resetPasswordModule.setToken(this.$route.query['resetPasswordToken'] as string);
    resetPasswordModule
      .fetchResetPasswordEmail()
      .then((d: TeacherPasswordReset) => {
        this.isResetRequestValid = true;
        resetPasswordModule.setEmail(d.email);
        resetPasswordModule.setPassword('');
        resetPasswordModule.setPasswordConfirm('');
      });
  }

  get isEmptyPassword(): boolean {
    return this.$v.password.$dirty && this.$v.password.$invalid;
  }

  get isPasswordOutOfRange(): boolean {
    return this.$v.password.$dirty && this.$v.password.$invalid == false && StringUtils.isValidPassword(this.password) === false;
  }

  get isEmptyPasswordConfirm(): boolean {
    return this.$v.passwordConfirm.$dirty && this.$v.passwordConfirm.$invalid;
  }

  get isDifferentPassword(): boolean {
    return this.isEmptyPassword === false && this.isEmptyPasswordConfirm === false && resetPasswordModule.isDifferentPassword;
  }

  get isPageInvalid(): boolean {
    return this.isEmptyPassword || this.isEmptyPasswordConfirm || this.isPasswordOutOfRange || this.isDifferentPassword;
  }

  get password(): string {
    return resetPasswordModule.password;
  }
  set password(value: string) {
    resetPasswordModule.setPassword(value);
  }
  get passwordConfirm(): string {
    return resetPasswordModule.passwordConfirm;
  }
  set passwordConfirm(value: string) {
    resetPasswordModule.setPasswordConfirm(value);
  }

  get isValid(): boolean {
    if (this.password == "" || this.passwordConfirm == "") return false;
    return !this.isEmptyPassword && !this.isEmptyPasswordConfirm && !this.isPasswordOutOfRange && !this.isDifferentPassword;
  }

  get isJgrow(): boolean {
    return process.env.VUE_APP_SERVICE_NAME === Constants.ServiceNameJgrow;
  }

  handleBackToLogin() {
    this.$router.push(`/signin`);
  }

  handleLinkToPwReset() {
    this.$router.push(`/reset-password/step1`);
  }

  handleCloseModal() {
    this.messageModal.isShow = false;
  }

}
